<template>
  <div id="diy-dialog-deduct-record">
    <!-- 扣分记录 -->
    <div class="item" v-for="(item, index) in data" :key="index">
      <div class="time">{{ item.time }}</div>
      <div class="content">
        <div class="p">{{ item.option }}</div>
        <div class="t">- {{ item.grade }}分</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "diy_dialog_deduct_record",
  props: {
    list: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      data: this.list,
    };
  },
  watch: {
    list() {
      this.data = this.list;
    },
    data(newValue) {
      this.$emit("showList", this.data);
    },
  },
};
</script>

<style lang="less" scoped>
#diy-dialog-deduct-record {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  > .item {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
    box-sizing: border-box;
    border-bottom: 1px solid #f1f1f1;
    padding: 10px;
    > .time {
      width: 100%;
      height: 35px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      font-size: 13px;
      color: #b8b8b8;
    }
    > .content {
      width: 100%;
      display: flex;
      align-items: center;
      font-size: 15px;
      margin-top: 6px;
      > .p {
        width: 0;
        flex: 1;
        height: auto;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-weight: bold;
        margin-right: 8px;
      }
      > .t {
        width: auto;
      }
    }
  }
}
</style>